import React from 'react';

import {
  UserCardOpen,
  UserCardClose,
  Icon,
  OpenName,
  CloseName,
  Email,
  UserCardOpenContent,
  CurrentIcon,
} from './styles';

interface Props {
  isOpen: boolean;
  isCurrent: boolean;
  isEdit?: boolean;
  email: string;
  name: string;
  lastName: string;
  onClickOpen?: (value: string) => void;
}

const UserOnboardingCard = ({ isOpen, isCurrent, email, name, lastName, onClickOpen, isEdit }: Props) => {
  if (isOpen) {
    return (
      <UserCardOpen
        isCursor={isEdit}
        onClick={() => {
          if (onClickOpen) onClickOpen(email);
        }}
      >
        <Icon>
          <img alt="user-icon" src="/corporate/images/user-icon.svg" />
        </Icon>
        <UserCardOpenContent>
          <OpenName>
            {name} {lastName}
          </OpenName>
          <Email>{email}</Email>
        </UserCardOpenContent>
        {isCurrent && (
          <CurrentIcon>
            <img alt="user-icon" src="/corporate/images/user-icon-check.svg" />
          </CurrentIcon>
        )}
      </UserCardOpen>
    );
  }

  return (
    <UserCardClose>
      <Icon>
        <img alt="user-icon" src="/corporate/images/user-icon.svg" />
      </Icon>
      <CloseName>
        {name} {lastName}
      </CloseName>
    </UserCardClose>
  );
};

export default UserOnboardingCard;
